const stack = localStorage.getItem("creativeIntelligenceStack");
const localApiKey = localStorage.getItem("creativeIntelligenceApiKey");

export const BaseUrl = `https://${stack}.api.dev.hogarth.ai/v1/query/okta`;
export const ApiKey = localApiKey ?? "nsHVT10FsH70s4jLHvGVjgXBDvz2fyL8bwUyhVFb";
